/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import classNames from 'classnames';
import { Col, ControlLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getSplitTestValue } from '@src/utils/selectors';

import styles from './AutoCompany.module.css';
import { getCountryCode } from '../../../lendingAPI/lendingAPISelector';
import DropDown from '../../DropDown';
import InternalLink from '../../InternalLink';
import messages from '../CompanyName.messages';

const mapStateToProps = (state) => ({
    country_code: getCountryCode(state),
    isBusinessDetailsReductionSplitTest:
        getSplitTestValue(state, 'business_details_reduction') &&
        getCountryCode(state) === 'uk'
});

class AutoCompany extends React.Component {
    invalidClassName(field) {
        return classNames({
            invalid: field.touched && field.error
        });
    }

    renderCompanyOption(option) {
        return (
            <span data-dd-privacy="mask" className="fs-exclude">
                {option.label}
                {option.value ? (
                    <span className="helper company-number">{` (${option.value})`}</span>
                ) : null}
            </span>
        );
    }

    renderNoResults = () => {
        const { toggle, country_code } = this.props;

        return (
            <div className="no-results-custom">
                <span className="head">
                    <FormattedMessage {...messages.companyNotFoundErrorTitle} />
                </span>

                {country_code === 'de' && (
                    <span className="body">
                        <FormattedMessage
                            {...messages.companyNotFoundErrorContent}
                        />
                        &nbsp;
                        <a
                            onClick={(e) => {
                                tracking.ampli.manualCompanyNameSelected({
                                    location_clicked_from: 'no_companies_found'
                                });
                                toggle(e);
                            }}>
                            <FormattedMessage
                                {...messages.manualCompanyToggleLinkText}
                            />
                        </a>
                    </span>
                )}
            </div>
        );
    };

    renderNoSearchTerm = () => {
        return (
            <div className="no-results-custom">
                <span className="head">
                    <FormattedMessage {...messages.searchForCompany} />
                </span>
                <span className="body">
                    <FormattedMessage {...messages.noSearchTermContent} />
                </span>
            </div>
        );
    };

    warningRenderer = () => {
        const { toggle, country_code } = this.props;
        return (
            <div className="no-results-custom">
                <span className="head">
                    <FormattedMessage {...messages.warningTitle} />
                </span>
                {country_code === 'de' && (
                    <span className="body">
                        <FormattedMessage {...messages.warningContent} />{' '}
                        <InternalLink
                            onClick={(e) => {
                                tracking.ampli.manualCompanyNameSelected({
                                    location_clicked_from: 'results_error'
                                });
                                toggle(e);
                            }}>
                            <FormattedMessage {...messages.warningLinkText} />
                        </InternalLink>
                    </span>
                )}
            </div>
        );
    };

    renderLocalisedLabel = () => {
        const { country_code } = this.props;
        switch (country_code) {
            case 'de':
                return <FormattedMessage {...messages.companyName} />;
            default:
                return 'Select your company';
        }
    };

    renderError = () => {
        const {
            useFieldError = false,
            company: {
                company_name: { error }
            }
        } = this.props;

        if (!error) return null;

        if (useFieldError) {
            return <FormattedMessage id={error} defaultMessage={error} />;
        }

        return <FormattedMessage {...messages.searchForCompanyName} />;
    };

    render() {
        const {
            companies,
            changeSearchTermOnNoCompanies,
            onSelect,
            onCompanyNameChange,
            company,
            toggle,
            initialSearchTerm,
            renderSearch,
            renderTopMenuElement,
            renderBottomMenuElement,
            country_code,
            labelProps = {},
            isBusinessDetailsReductionSplitTest
        } = this.props;
        const label = this.renderLocalisedLabel();

        return (
            <Col
                xs={12}
                sm={isBusinessDetailsReductionSplitTest ? 12 : 6}
                className={classNames(
                    this.invalidClassName(company.company_name),
                    {
                        [styles.formFieldBusinessDetailsReduction]:
                            isBusinessDetailsReductionSplitTest
                    }
                )}>
                <ControlLabel
                    {...labelProps}
                    className={
                        isBusinessDetailsReductionSplitTest &&
                        styles.companyLabelBusinessDetailsReduction
                    }>
                    {label}
                </ControlLabel>

                {country_code === 'uk' &&
                    isBusinessDetailsReductionSplitTest && (
                        <div
                            className={classNames(styles.underLabel, {
                                [styles.underLabelBusinessDetailsReduction]:
                                    isBusinessDetailsReductionSplitTest
                            })}>
                            Your company must be registered with Companies House
                        </div>
                    )}

                <div className="error">{this.renderError()}</div>
                <DropDown.AsyncLive
                    className={['company-search']}
                    getOptions={onCompanyNameChange}
                    items={companies.list}
                    changeSearchTermOnNoItems={changeSearchTermOnNoCompanies}
                    isSuccess={companies.success}
                    optionRenderer={this.renderCompanyOption}
                    isLoading={companies.fetching}
                    value={company.company_number.value}
                    manualSwitch={toggle}
                    onSelect={onSelect}
                    noResultsRenderer={this.renderNoResults}
                    noSearchTermRenderer={this.renderNoSearchTerm}
                    warningRenderer={this.warningRenderer}
                    selectedLabel={company.company_name.value}
                    initialSearchTerm={initialSearchTerm}
                    renderSearch={renderSearch}
                    renderTopMenuElement={renderTopMenuElement}
                    renderBottomMenuElement={renderBottomMenuElement}
                />

                {/* Note: Split test move the description above the input field. */}
                {country_code === 'uk' &&
                    !isBusinessDetailsReductionSplitTest && (
                        <div className={styles.underLabel}>
                            Your company must be registered with Companies House
                        </div>
                    )}

                {country_code === 'de' && (
                    <div className="toggle-company-link">
                        <FormattedMessage {...messages.manualCompanyToggle} />
                        <a
                            onClick={(event) => {
                                tracking.ampli.manualCompanyNameSelected({
                                    location_clicked_from: 'initial_toggle'
                                });
                                this.props.toggle(event);
                            }}>
                            <FormattedMessage
                                {...messages.manualCompanyToggleLinkText}
                            />
                        </a>
                    </div>
                )}
            </Col>
        );
    }
}

export default connect(mapStateToProps, null)(AutoCompany);
